import { previewDashboardSearchSchema } from '@/config/commonSearch';
import { z } from 'zod';

export const budgetOptimizationSearchSchema =
    previewDashboardSearchSchema.extend({
        budget: z.number().optional(),
        optimizationBase: z
            .enum(['budget', 'media_kpi', 'total_kpi'])
            .default('budget')
            .catch('budget'),
    });

export { BudgetOptimization } from './BudgetOptimization';
